import api from "../api/api";
import {
  CreateMultilingualGenerationTasksApiProps,
  CreateMultilingualGenerationVideoTaskMessageProps,
} from "./props";

export const gennerateMultilingualGenerationTasksApi = async (
  data: CreateMultilingualGenerationTasksApiProps
) => {
  return await api.post<CreateMultilingualGenerationVideoTaskMessageProps>(
    "/api/video/ppt_multilingual",
    data
  );
};
